import React from 'react'

const FormField = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  autoComplete,
  required,
  children,
  className = ''
}) => (
  <div className={`space-y-2 ${className}`}>
    {label && (
      <label className="block text-sm font-medium text-gray-200">
        {label}
      </label>
    )}
    {children || (
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10"
      />
    )}
  </div>
)

export const TextInput = ({ value, onChange, placeholder, className = '' }) => (
  <input
    type="text"
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    className={`w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10 ${className}`}
  />
)

export const DateInput = ({ value, onChange, className = '' }) => (
  <input
    type="date"
    value={value}
    onChange={onChange}
    className={`w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10 ${className}`}
  />
)

export const TextArea = ({ value, onChange, placeholder, rows = 3, maxLength = 500, showCounter = true }) => (
  <div>
    <textarea
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      className="w-full px-4 py-3 bg-white/5 border border-white/20 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300 hover:bg-white/10 resize-none"
    />
    {showCounter && (
      <div className="text-gray-400 text-xs mt-1">
        {value.length}/{maxLength} characters
      </div>
    )}
  </div>
)

export default FormField